var map = {
	"./n1.jpg": 9948,
	"./n2.jpg": 3877,
	"./n3.jpg": 3658,
	"./n4.jpg": 5694,
	"./n5.jpg": 8110,
	"./n6.jpg": 812,
	"./n7.jpg": 9500,
	"./n8.jpg": 3864,
	"./n9.jpg": 9917
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 230;